// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangePasswordModal_overlay__kUy9E {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001; /* Higher than other modals */
}

.ChangePasswordModal_modal__n-w9q {
  background: rgba(24, 26, 27, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 90%;
  max-width: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: white;
}

.ChangePasswordModal_header__ef4zW {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(30, 30, 30, 0.7);
}

.ChangePasswordModal_header__ef4zW h2 {
  margin: 0;
  font-size: 1.3rem;
  color: #4a9eff;
  font-weight: bold;
}

.ChangePasswordModal_closeButton__cBnPG {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #ccc;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.ChangePasswordModal_closeButton__cBnPG:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.ChangePasswordModal_form__ws2Fm {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ChangePasswordModal_inputGroup__n-K0r {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ChangePasswordModal_inputGroup__n-K0r label {
  font-weight: 500;
  color: #ccc;
  font-size: 0.9rem;
}

.ChangePasswordModal_inputGroup__n-K0r input {
  padding: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.3);
  color: white;
  font-size: 0.9rem;
  transition: border-color 0.2s;
}

.ChangePasswordModal_inputGroup__n-K0r input:focus {
  outline: none;
  border-color: #4a9eff;
  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);
}

.ChangePasswordModal_inputGroup__n-K0r input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.ChangePasswordModal_error__hiS28 {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
  border: 1px solid rgba(244, 67, 54, 0.3);
  padding: 0.75rem;
  border-radius: 4px;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.ChangePasswordModal_success__MUVYX {
  background-color: rgba(76, 175, 80, 0.1);
  color: #4caf50;
  border: 1px solid rgba(76, 175, 80, 0.3);
  padding: 0.75rem;
  border-radius: 4px;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.ChangePasswordModal_footer__dkM73 {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.ChangePasswordModal_cancelButton__JjnUk {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.ChangePasswordModal_cancelButton__JjnUk:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
}

.ChangePasswordModal_saveButton__wojU7 {
  background: #4a9eff;
  border: none;
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
  min-width: 120px;
}

.ChangePasswordModal_saveButton__wojU7:hover {
  background: #3a8aff;
  transform: translateY(-1px);
}

.ChangePasswordModal_saveButton__wojU7:disabled,
.ChangePasswordModal_cancelButton__JjnUk:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 480px) {
  .ChangePasswordModal_modal__n-w9q {
    width: 95%;
    margin: 1rem;
  }
  
  .ChangePasswordModal_header__ef4zW,
  .ChangePasswordModal_form__ws2Fm {
    padding: 1rem;
  }
  
  .ChangePasswordModal_header__ef4zW h2 {
    font-size: 1.2rem;
  }
  
  .ChangePasswordModal_footer__dkM73 {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .ChangePasswordModal_saveButton__wojU7,
  .ChangePasswordModal_cancelButton__JjnUk {
    width: 100%;
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChangePasswordModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1001; /* Higher than other modals */\r\n}\r\n\r\n.modal {\r\n  background: rgba(24, 26, 27, 0.95);\r\n  backdrop-filter: blur(15px);\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  width: 90%;\r\n  max-width: 400px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  color: white;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1.5rem;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n  background: rgba(30, 30, 30, 0.7);\r\n}\r\n\r\n.header h2 {\r\n  margin: 0;\r\n  font-size: 1.3rem;\r\n  color: #4a9eff;\r\n  font-weight: bold;\r\n}\r\n\r\n.closeButton {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  color: #ccc;\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.closeButton:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  color: white;\r\n}\r\n\r\n.form {\r\n  padding: 1.5rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.inputGroup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.inputGroup label {\r\n  font-weight: 500;\r\n  color: #ccc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.inputGroup input {\r\n  padding: 0.75rem;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n  background-color: rgba(0, 0, 0, 0.3);\r\n  color: white;\r\n  font-size: 0.9rem;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.inputGroup input:focus {\r\n  outline: none;\r\n  border-color: #4a9eff;\r\n  box-shadow: 0 0 0 2px rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.inputGroup input::placeholder {\r\n  color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.error {\r\n  background-color: rgba(244, 67, 54, 0.1);\r\n  color: #f44336;\r\n  border: 1px solid rgba(244, 67, 54, 0.3);\r\n  padding: 0.75rem;\r\n  border-radius: 4px;\r\n  font-size: 0.9rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.success {\r\n  background-color: rgba(76, 175, 80, 0.1);\r\n  color: #4caf50;\r\n  border: 1px solid rgba(76, 175, 80, 0.3);\r\n  padding: 0.75rem;\r\n  border-radius: 4px;\r\n  font-size: 0.9rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  margin-top: 1rem;\r\n  padding-top: 1rem;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.cancelButton {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.cancelButton:hover {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  border-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.saveButton {\r\n  background: #4a9eff;\r\n  border: none;\r\n  color: white;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  min-width: 120px;\r\n}\r\n\r\n.saveButton:hover {\r\n  background: #3a8aff;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.saveButton:disabled,\r\n.cancelButton:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  transform: none;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .modal {\r\n    width: 95%;\r\n    margin: 1rem;\r\n  }\r\n  \r\n  .header,\r\n  .form {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .header h2 {\r\n    font-size: 1.2rem;\r\n  }\r\n  \r\n  .footer {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .saveButton,\r\n  .cancelButton {\r\n    width: 100%;\r\n    padding: 1rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `ChangePasswordModal_overlay__kUy9E`,
	"modal": `ChangePasswordModal_modal__n-w9q`,
	"header": `ChangePasswordModal_header__ef4zW`,
	"closeButton": `ChangePasswordModal_closeButton__cBnPG`,
	"form": `ChangePasswordModal_form__ws2Fm`,
	"inputGroup": `ChangePasswordModal_inputGroup__n-K0r`,
	"error": `ChangePasswordModal_error__hiS28`,
	"success": `ChangePasswordModal_success__MUVYX`,
	"footer": `ChangePasswordModal_footer__dkM73`,
	"cancelButton": `ChangePasswordModal_cancelButton__JjnUk`,
	"saveButton": `ChangePasswordModal_saveButton__wojU7`
};
export default ___CSS_LOADER_EXPORT___;
